import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PhasesList from "../components/PhasesList";


const PhasesListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Phases" />

        {/* PhasesListLayer */}
        <PhasesList />

      {/* </MasterLayout> */}

    </>
  );
};

export default PhasesListPage; 
